<template>
    <field-wrapper
        class="field-StopLocation"
        :label-text="texts.label"
        :error-text="texts.error_duplicate"
        :show-error="hasDuplicates"
    >
        <selector-stoplocation
            :type="type"
            :enable-geo="enableGeo"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import SelectorStoplocation from "@/components/selectors/SelectorStoplocation";
import { mapGetters } from "vuex";

export default {
    components: {
        FieldWrapper,
        SelectorStoplocation
    },
    props: {
        texts: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        enableGeo: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters({
            hasDuplicates: "location/hasDuplicates"
        })
    }
};
</script>
